export default function PageLayout({ children }) {
  return (
    <div
      className="
        anim-in
        relative
        min-h-[100dvh]
        [overflow-x:clip]
        bg-gradient-to-b
        from-[#f8fbff] via-[#f4f8fc] to-[#eef4fb]
        dark:from-[#0d1829] dark:via-[#0f172a] dark:to-[#0a1220]
      "
    >
      {/* 🔥 AMBIENT BACKGROUND */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">

        {/* TOP LIGHT */}
        <div className="absolute -top-24 right-[-60px] h-72 w-72 rounded-full bg-blue-200/20 dark:bg-blue-700/15 blur-2xl" />

        {/* SECONDARY LIGHT */}
        <div className="absolute top-[20%] left-[-120px] h-80 w-80 rounded-full bg-cyan-100/30 dark:bg-cyan-900/15 blur-2xl" />

        {/* BOTTOM LIGHT */}
        <div className="absolute bottom-[-120px] left-[-80px] h-80 w-80 rounded-full bg-sky-100/30 dark:bg-indigo-900/15 blur-2xl" />

      </div>

      {/* 🔥 CONTENT */}
      <div className="relative z-10">

        {/* 🔥 MOBILE CONTAINER */}
        <div
          className="
            w-full
            max-w-screen-sm md:max-w-2xl
            mx-auto
            min-h-[100dvh]
            pb-[calc(110px+env(safe-area-inset-bottom))]
          "
        >
          {children}
        </div>

      </div>
    </div>
  );
}